import { DropdownOption } from '@urbanx/agx.ui-components2';
import { Agreements } from '@urbanx/agx.agencies.client';

export const nswAgreementOptions: DropdownOption[] = [
  {
    value: Agreements.NSWResidentialAgreement.toString(),
    label: 'NSW Residential Agreement',
  },
  {
    value: Agreements.NSWRuralAgreement.toString(),
    label: 'NSW Rural Agreement',
  },
];
